<template>
  <div class="about">
    <h1>会社概要</h1>
    <div class="about-table">
      <table class="ui very basic table">
        <tbody>
        <tr>
          <td>会社名</td>
          <td>合同会社埜式 | Noshiki,LLC</td>
        </tr>
        <tr>
          <td>設立</td>
          <td>2018年12月</td>
        </tr>
        <tr>
          <td>代表社員</td>
          <td>河埜洋平</td>
        </tr>
        <tr>
          <td>事業内容</td>
          <td>公演予約サービス PASSKETの企画・開発・運用<br>
            受託開発、コンサルティング
          </td>
        </tr>
        <tr>
          <td>所在地</td>
          <td>神奈川県鎌倉市山崎１４７１−３０</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3300.141525325757!2d139.5239287102023!3d35.33809656230812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60184f8717b780b5%3A0x630f23f07136f7c6!2z44CSMjQ3LTAwNjYg56We5aWI5bed55yM6Y6M5YCJ5biC5bGx5bSO77yR77yU77yX77yR4oiS77yT77yQ!5e0!3m2!1sja!2sjp!4v1577437836849!5m2!1sja!2sjp"
        frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2,h3 {
    font-weight: 900;
    color: black;
  }
  p{
    color: black;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .about{
    margin-top: 110px;
  }
  .about-table {
    margin: 30px 15%;
  }
  .map {
    position: relative;
    margin: 50px 15%;
    padding-bottom: 40%;
    overflow: hidden;
  }
  .map iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/About.vue